export default __webpack_public_path__ + "static/media/exit.d3e7258f.svg";